import { useState } from 'react';
import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Badge } from '@/components/ui/badge';
import { UnifiedInbox } from '@/components/dashboard/UnifiedInbox';
import { useUnifiedInbox } from '@/hooks/useUnifiedInbox';

interface NotificationBellProps {
  workspaceId: string | null;
  onOpenTeamMessages?: (recipientId?: string) => void;
  onOpenAccessRequests?: () => void;
}

export const NotificationBell = ({ workspaceId, onOpenTeamMessages, onOpenAccessRequests }: NotificationBellProps) => {
  const [open, setOpen] = useState(false);
  const inbox = useUnifiedInbox(workspaceId);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Inbox className="h-5 w-5" />
          {inbox.totalUnread > 0 && (
            <Badge
              variant="destructive"
              className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
            >
              {inbox.totalUnread > 9 ? '9+' : inbox.totalUnread}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] p-0" align="end">
        <UnifiedInbox
          notifications={inbox.notifications}
          categorizedNotifications={inbox.categorizedNotifications}
          messages={inbox.messages}
          accessRequests={inbox.accessRequests}
          loading={inbox.loading}
          unreadMessages={inbox.unreadMessages}
          pendingRequests={inbox.pendingRequests}
          unreadMentions={inbox.unreadMentions}
          totalUnread={inbox.totalUnread}
          onMarkAsRead={inbox.markAsRead}
          onMarkAllAsRead={inbox.markAllAsRead}
          onClose={() => setOpen(false)}
          onOpenTeamMessages={(recipientId) => {
            setOpen(false);
            onOpenTeamMessages?.(recipientId);
          }}
          onOpenAccessRequests={() => {
            setOpen(false);
            onOpenAccessRequests?.();
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
